import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";
import { cls } from "app/utils";
import { DateTime } from "luxon";

interface Props {
  score: any;
  onOpenModal: () => void;
}

const ScoreCard = ({ score, onOpenModal }: Props) => {
  const { t } = useTranslation();
  const hasScorecard = score?.isHbh;

  return (
    <div className={cls(styles.score_card_container, { [styles.clickable]: hasScorecard })} onClick={hasScorecard ? onOpenModal : null}>
      <div className={styles.first_half}>
        <div className={styles.gross_score_container}>
          <span className={styles.gross_score}>
            {score.adjustedGrossScore}
          </span>
        </div>

        <div className={styles.score_info_container}>
          <div className={styles.row}>
            <span className={styles.date}>
              {DateTime.fromISO(score.playedAt).toFormat("MMM d, yyyy")}
            </span>
            {!hasScorecard && (
              <span className={styles.no_scorecard}>
                {t('No Scorecard')}
              </span>
            )}
          </div>

          <p className={styles.course_name}>
            {score.courseDisplayValue}
          </p>

          <span className={styles.rating}>
            {`${score.courseRating.toFixed(1)} / ${score.slopeRating} • ${t(
              'Differential: {{differential}}',
              { differential: score.differential.toFixed(1) }
            )}`}
          </span>
        </div>
      </div>

      {hasScorecard && (
        <i className={cls("ico ico-chevron", styles.arrow)} />
      )}
    </div>
  );
};

export default ScoreCard;
